import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Editor } from "@tinymce/tinymce-react";
import Sidebar from "../../../../partials/aside/Sidebar";
import TitleBar from "../../../../partials/content/TitleBar";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import parse from "html-react-parser";

const positions = {
  top: "top",
  left: "left",
  middle: "middle",
  right: "right",
};

export default function Add() {
  const history = useHistory();

  const [render, reRender] = useState(false);

  const [positionTexts, setPositionTexts] = useState({
    top: {
      title: "",
      text: "",
    },
    left: {
      title: "",
      text: "",
    },
    middle: {
      title: "",
      text: "",
    },
    right: {
      title: "",
      text: "",
    },
  });

  const [position, setPosition] = useState(positions.top);

  const apiKey = "n0pnn5k9s0m0dsdttkjemajjkwr2ud59f1m3kvan1f8skwc5";
  const pluginsTinyMCEEditor = "lists link";
  const toolBarTinyMCEEditor =
    " undo redo fontsize |  numlist bullist checklist link |  bold italic underline forecolor backcolor | alignleft aligncenter alignright alignjustify lineheight | checklist  indent outdent |  ";

  const bodyStyleTinyMCEEditor = "body {direction: rtl}";

  const [roles, setRoles] = useState([]);

  useEffect(() => {
    getRoles();
  }, []);

  const getRoles = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let roles = await sendRequestGetRoles();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!roles) {
      return;
    }
    setRoles(roles);
  };

  const sendRequestGetRoles = async () => {
    const headersRequest = getHeaderForRequest();
    let roles;
    try {
      roles = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/role",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return roles.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateRolesRadioButton = () => {
    return roles.map((role) => {
      return (
        <div className="col-12 col-sm-2 col-md-2">
          <span className=" justify-content-between d-inline-flex align-items-center py-2 ">
            <span>
              <input
                className="hover"
                type="radio"
                name="role"
                value={role.rol_id}
                required
              />
            </span>
            <span className="pr-2 small font-weight-bold text-nowrap ">
              {role.rol_persian_name}
            </span>
          </span>
        </div>
      );
    });
  };

  const generateRoles = () => {
    return (
      <div className="alert alert-secondary p-2">
        <div className="form-group">
          <div className="container-fluid">
            <div className="row">{generateRolesRadioButton()}</div>
          </div>
        </div>
      </div>
    );
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const roleID = document.querySelector('input[name="role"]:checked').value;
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const result = await sendRequestAddNotificationDesktop({
      text: JSON.stringify(positionTexts),
      user_role: roleID,
    });
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!result) {
      return;
    }
    history.push("/user/notification-dashboard/all");
  };

  const sendRequestAddNotificationDesktop = async (data) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/notification-dashboard/manage",
        data,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اطلاع رسانی های داشبورد" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="text-white"
                  to="/user/notification-dashboard/all"
                >
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>
              <div>
                <form onSubmit={sendForm}>
                  <div>{roles && generateRoles()}</div>
                  <div>
                    <span>موقعیت متن :</span>
                    <span className="px-2">
                      <span>
                        <input
                          defaultChecked="checked"
                          type="radio"
                          className="hover"
                          name="position"
                          value="top"
                          onChange={(e) => {
                            setPosition(positions.top);
                          }}
                        />
                      </span>
                      <span className="px-2">بالا</span>
                    </span>

                    <span className="px-2">
                      <span>
                        <input
                          type="radio"
                          className="hover"
                          name="position"
                          value="right"
                          onChange={(e) => {
                            setPosition(positions.right);
                          }}
                        />
                      </span>
                      <span className="px-2">راست</span>
                    </span>

                    <span className="px-2">
                      <span>
                        <input
                          type="radio"
                          className="hover"
                          name="position"
                          value="middle"
                          onChange={(e) => {
                            setPosition(positions.middle);
                          }}
                        />
                      </span>
                      <span className="px-2">وسط</span>
                    </span>

                    <span className="px-2">
                      <span>
                        <input
                          type="radio"
                          className="hover"
                          name="position"
                          value="left"
                          onChange={(e) => {
                            setPosition(positions.left);
                          }}
                        />
                      </span>
                      <span className="px-2">چپ</span>
                    </span>
                  </div>
                  <h2>عنوان</h2>
                  <div className="form-group">
                    <Editor
                      apiKey={apiKey}
                      value={positionTexts[position].title}
                      onEditorChange={(content) => {
                        setPositionTexts((prevState) => {
                          prevState[position].title = content;
                          return prevState;
                        });
                        reRender((prevState) => !prevState);
                      }}
                      init={{
                        custom_undo_redo_levels: false,
                        // custom_undo_redo_keyboard_shortcuts: false,
                        height: 200,
                        menubar: false,
                        plugins: pluginsTinyMCEEditor,
                        toolbar: toolBarTinyMCEEditor,
                        content_style: bodyStyleTinyMCEEditor,
                        default_link_target: "_blank",
                      }}
                    />
                  </div>
                  <h2>متن</h2>
                  <div className="form-group">
                    <Editor
                      apiKey={apiKey}
                      value={positionTexts[position].text}
                      onEditorChange={(content) => {
                        setPositionTexts((prevState) => {
                          prevState[position].text = content;
                          return prevState;
                        });
                        reRender((prevState) => !prevState);
                      }}
                      init={{
                        height: 300,
                        menubar: false,
                        plugins: pluginsTinyMCEEditor,
                        toolbar: toolBarTinyMCEEditor,
                        content_style: bodyStyleTinyMCEEditor,
                        default_link_target: "_blank",
                      }}
                    />
                  </div>
                  <hr />
                  <h4>پیش نمایش</h4>
                  <hr />
                  <div id="preview-notification-dashboard">
                    <div>
                      <div
                        className="pt-4 border border-1 border-dark"
                        id="welcome-advertiser-container"
                      >
                        <div className="px-3 welcome-advertiser-header border-bottom border-dark">
                          <div className="position-relative">
                            <div className="position-absolute image-title-cover">
                              <img
                                className="img-fluid"
                                src="/assets/img/red-highlight-cover-title.svg"
                              />
                            </div>
                            <div className="position-relative text-center">
                              {parse(positionTexts.top.title)}
                            </div>
                          </div>
                          <div>{parse(positionTexts.top.text)}</div>
                        </div>
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-4 px-3 welcome-items discount border-dark">
                              <div className="position-relative pt-3">
                                <div className="position-absolute image-title-cover">
                                  <img
                                    className="img-fluid"
                                    src="/assets/img/green-highlight-cover-title.svg"
                                  />
                                </div>
                                <div
                                  className="position-relative text-center"
                                  style={{ zIndex: 9 }}
                                >
                                  {parse(positionTexts.right.title)}
                                </div>
                              </div>
                              <div className="px-2">
                                {parse(positionTexts.right.text)}
                              </div>
                            </div>
                            <div className="col-12 col-lg-4 px-3 welcome-items solution-reduce-cost border-dark">
                              <div className="position-relative pt-3">
                                <div className="position-absolute image-title-cover">
                                  <img
                                    className="img-fluid"
                                    src="/assets/img/green-highlight-cover-title.svg"
                                  />
                                </div>
                                <div
                                  className="position-relative text-center"
                                  style={{ zIndex: 9 }}
                                >
                                  {parse(positionTexts.middle.title)}
                                </div>
                              </div>
                              <div className="px-2">
                                {parse(positionTexts.middle.text)}
                              </div>
                            </div>
                            <div className="col-12 col-lg-4 px-3 welcome-items important-tips">
                              <div className="position-relative pt-3">
                                <div className="position-absolute image-title-cover">
                                  <img
                                    className="img-fluid"
                                    src="/assets/img/green-highlight-cover-title.svg"
                                  />
                                </div>
                                <div
                                  className="position-relative text-center"
                                  style={{ zIndex: 9 }}
                                >
                                  {parse(positionTexts.left.title)}
                                </div>
                              </div>
                              <div className="px-2">
                                {parse(positionTexts.left.text)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="pt-3">
                    <button className="btn btn-success">اضافه کردن</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
